import { inWindowTool } from './../utils/inWindow';
export const emailPattern = /^([^@]+)@([a-zA-Z0-9_\-.]+\.[a-zA-Z0-9]{2,})$/;
export const emailNsPattern = /^([a-zA-Z0-9_\-.]+\.[a-zA-Z0-9]{2,})$/;
export const zhPattern = /[\u4e00-\u9fa5]/;
const MonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const formatterMap = {
    'zh-month': (month) => month + '月',
    'en-month': (month) => {
        if (month === undefined) {
            throw new Error('month is undefined');
        }
        return MonthList[+month - 1];
    },
    'zh-year-month': (_date) => {
        const date = new Date(+_date);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        return year + '年' + month + '月';
    },
    'en-month-year': (_date) => {
        const date = new Date(+_date);
        const year = date.getFullYear();
        const month = date.getMonth();
        return MonthList[month] + ' ' + year;
    },
};
export const getIn18Text = (key, values) => {
    let text = '';
    if (typeof key === 'string') {
        text = typeof window !== 'undefined' ? window.getLocalLabel(key) : '';
        if (!text && zhPattern.test(key)) {
            text = key;
        }
    }
    else if (Array.isArray(key)) {
        text = key
            .map(v => {
            const label = typeof window !== 'undefined' ? window.getLocalLabel(v) : '';
            if (!label && zhPattern.test(v)) {
                return v;
            }
            return label;
        })
            .join('');
    }
    try {
        if (values && /\{[^{}]+\}/.test(text)) {
            const pattern = /\{([^{}]+)\}/g;
            text = text.replace(pattern, (match, p1) => {
                if (p1) {
                    const arr = p1.split(',');
                    if (arr.length === 2) {
                        const jsonKey = arr[0].trim();
                        const formatterKey = arr[1].trim();
                        let key2Value = jsonKey;
                        if (jsonKey && values[jsonKey] !== undefined) {
                            key2Value = values[jsonKey] + '';
                        }
                        if (formatterKey && formatterMap[formatterKey] !== undefined) {
                            key2Value = formatterMap[formatterKey](key2Value);
                        }
                        return key2Value;
                    }
                    if (arr.length === 1) {
                        const jsonKey = arr[0].trim();
                        if (jsonKey && values[jsonKey] !== undefined) {
                            return values[jsonKey] + '';
                        }
                    }
                }
                return match;
            });
        }
    }
    catch (e) {
        console.error('[Error getIn18Text]', e);
    }
    return text;
};
export const getIn18TextByLang = (key, lang) => {
    try {
        return typeof window !== 'undefined' ? window.getLocalLabel({ path: key, lang }) : '';
    }
    catch (e) {
        console.error('[Error getIn18TextByLang]', e);
        return '';
    }
};
export const setMailAttSource = (res, from) => {
    try {
        if (res) {
            if (Array.isArray(res)) {
                res.forEach(v => {
                    v.entry.attSource = from;
                });
            }
            else if (res === null || res === void 0 ? void 0 : res.entry) {
                res.entry.attSource = from;
            }
        }
    }
    catch (e) {
        console.error('[attSource Error]', e);
    }
    return res;
};
export const setMailListAttSource = (res, from) => {
    try {
        if (res) {
            if (Array.isArray(res)) {
                res.forEach(v => {
                    v.entry.attSource = from;
                });
            }
            else if ((res === null || res === void 0 ? void 0 : res.data) && Array.isArray(res.data)) {
                res.data.forEach(item => {
                    var _a;
                    if (item && !((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.attSource)) {
                        item.entry.attSource = from;
                    }
                });
            }
        }
    }
    catch (e) {
        console.error('[attSource Error]', e);
    }
    return res;
};
export const jsonSafeParse = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        console.warn('jsonSafeParse', e);
        return null;
    }
};
export var ERequestDelayTime;
(function (ERequestDelayTime) {
    ERequestDelayTime[ERequestDelayTime["short"] = 5000] = "short";
    ERequestDelayTime[ERequestDelayTime["normal"] = 10000] = "normal";
    ERequestDelayTime[ERequestDelayTime["middle"] = 30000] = "middle";
    ERequestDelayTime[ERequestDelayTime["long"] = 60000] = "long";
})(ERequestDelayTime || (ERequestDelayTime = {}));
export const isWindows7 = () => {
    if (inWindowTool()) {
        return navigator.userAgent.toLowerCase().indexOf('windows nt 6.1') !== -1;
    }
    return false;
};
